import React, { useState, useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { Container, Fab } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { withTranslation } from 'react-i18next'
import { PageContext } from '../Context/PageProvider'
import Header from '../Components/Header'
import FilterBar from '../Components/FilterBar'
import CustomTable from '../Components/CustomTable'
import AddIcon from '@material-ui/icons/Add'
import MessageModal from '../Components/MessageModal'

function Messages({ t, history }) {

    const classes = useStyles()
    const context = useContext(PageContext)
    const [openModal, setOpenModal] = useState(false)

    const messages = context.messages
    if (!messages) return null

    return (
        <Container className={classes.root}>
            <Header />
            <FilterBar />
            <CustomTable />
            <Fab aria-label="add" color="primary" className={classes.addButton} onClick={() => setOpenModal(true)}>
                <AddIcon />
            </Fab>
            {
                openModal && <MessageModal open={true} handleClose={() => setOpenModal(false)} />
            }

        </Container>
    )
}


const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: '100%',
        padding: 0,
        backgroundColor: theme.palette.common.white
    },
    addButton: {
        position: 'fixed',
        bottom: '30px',
        right: '30px',
        zIndex: '99999',
    }
}))

export default withTranslation()(withRouter(Messages))